import { createDefaultDeviceProvider } from '@coursera/event-pulse/core';

export default createDefaultDeviceProvider();
